import { Component, input, viewChild } from '@angular/core';
import { Button, Notification } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  imports: [Notification, Button, NgIcon, RouterLink, TranslocoPipe],
  templateUrl: './energy-interfaces-create-success-notification.html',
})
export class EnergyInterfacesCreateSuccessNotification {
  notification = viewChild(Notification);

  uuid = input.required<string>();
  duration = input.required<number>();

  organizationId = input.required<string>();
  energyInterfaceId = input.required<string>();
  energyInterfaceLabel = input.required<string>();
}
